import clsx from 'clsx';
import { FC } from 'react';

import styles from './styles.module.css';

interface Props {
  activeIndex: number;
}

const classNames: Record<number, string> = {
  1: styles.variantB,
  2: styles.variantC,
};

const SlidePattern: FC<Props> = ({ activeIndex }) => {
  const positionVariant = activeIndex % 3;

  return (
    <div className={classNames[positionVariant]}>
      <div className={clsx(styles.pattern, styles.a)} />
      <div className={clsx(styles.pattern, styles.b)} />
      <div className={clsx(styles.pattern, styles.c)} />
      <div className={clsx(styles.pattern, styles.d)} />
      <div className={clsx(styles.pattern, styles.e)} />
      <div className={clsx(styles.pattern, styles.f)} />
      <div className={clsx(styles.pattern, styles.g)} />
      <div className={clsx(styles.pattern, styles.h)} />
      <div className={clsx(styles.pattern, styles.i)} />
      <div className={clsx(styles.pattern, styles.j)} />
      <div className={clsx(styles.pattern, styles.k)} />
    </div>
  );
};

export default SlidePattern;
